import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import { getCustomerById, saveCustomer, updateCustomer } from "../../actions/CustomerActions";
import Select from "react-select";
import { styleSelect } from "../../constants/customStyles";
import { getProductAttributes, getProductAttributesValue, getProductById, updateProduct } from "../../actions/ProductActions";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import Mobilemenu from "../../layouts/mobile-menu";

function EditProduct() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        dispatch(getProductById(params.id));
        dispatch(getAllProductCategory(null, 99999, ''));

    }, []);

    const product = useSelector(state => state?.product?.product);
    const productCategories = useSelector(state => state?.productCategory?.productCategories?.data)

    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [costPrice, setCostPrice] = useState('');
    const [salePrice, setSalePrice] = useState('');
    const [productCategory, setProductCategory] = useState('');

    useEffect(() => {
        if (Object.keys(product).length > 0) {
            setName(product.name);
            setType(product.product_type);
            setProductCategory(product.product_category_id);
        }
    }, [product])

    const save = () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
                cost_price: costPrice,
                sale_price: salePrice,
                product_type: type,
                product_category: productCategory,
            }
            dispatch(updateProduct(data, params.id));
        }
    }

    const Options = [
        { value: 'goods', label: 'Spare Parts' },
        { value: 'service', label: 'Repairs' },
    ]

    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Edit Product
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12">
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Name :</label>
                                        <input id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Enter Name" />
                                    </div>
                                    <div className="g-col-12 g-col-md-6">
                                        <label for="crud-form-1" className="form-label">Product Category</label>
                                        <select className="form-control" onChange={(e) => {
                                            setProductCategory(e.target.value);
                                        }}>
                                            {
                                                productCategories && productCategories.length > 0 &&
                                                productCategories.map(category => {
                                                    return (
                                                        <option selected={productCategory == category.id ? 'selected' : ''} value={category.id}>{category.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="email" className="form-label">Cost Price :</label>
                                        <input id="email" name="email" type="text" onChange={(e) => setCostPrice(e.target.value)} className="form-control" placeholder="Enter Cost Price" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">Sale Price :</label>
                                        <input id="mobile" name="mobile" type="text" onChange={(e) => setSalePrice(e.target.value)} className="form-control" placeholder="Enter Sale Price" />
                                    </div>
                                    <div className="g-col-12 g-col-md-6">
                                        <label for="crud-form-1" className="form-label">Product Type</label>
                                        <select className="form-control" onChange={(e) => {
                                            setType(e.target.value);
                                        }}>
                                            <option value={''}>Please Select</option>
                                            {
                                                Options && Options.length > 0 &&
                                                Options.map(option => {
                                                    return (
                                                        <option selected={type == option.value ? 'selected' : ''} value={option.value}>{option.label}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/products')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <button type="button" onClick={save} className="btn btn-primary w-24">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditProduct;